import { z } from 'zod/v4';

export const bodySchema = z.object({
  fileId: z.string().optional(),
  directory: z.string(),
  file: z.string(),
});

export type BodySchemaGroup = z.infer<typeof bodySchema>;
